import { render, staticRenderFns } from "./AreasPrioritarias.vue?vue&type=template&id=602c62d4&lang=pug"
import script from "./AreasPrioritarias.vue?vue&type=script&lang=js"
export * from "./AreasPrioritarias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports